import { callFunction } from "./functions-client";

// Server-synced bookmarks (jobs/loads) — a member's saved list follows their
// account across devices. Use the SavedContext / useSaved() hook in the UI so
// reads are instant; these are the underlying calls.
export type SavedKind = "jobs" | "loads";

export const listSaved = () =>
  callFunction<{ jobs: string[]; loads: string[] }>("saved/list", { method: "GET" });

export const toggleSaved = (kind: SavedKind, item_id: string) =>
  callFunction<{ saved: boolean }>("saved/toggle", { body: { kind, item_id } });
